export default __webpack_public_path__ + "static/media/label_detect_image.14cd3ca7.jpg";